import { Skeleton } from '@/components/ui/skeleton';

// Conversation list skeleton loader
export const ConversationSkeleton = () => (
  <div className="p-3 animate-pulse">
    <div className="flex items-start gap-3">
      <Skeleton className="w-10 h-10 rounded-full" />
      <div className="flex-1 space-y-2">
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-3 w-16" />
        </div>
        <Skeleton className="h-3 w-3/4" />
      </div>
    </div>
  </div>
);

// Multiple conversation skeletons
export const ConversationListSkeleton = ({ count = 5 }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <ConversationSkeleton key={i} />
    ))}
  </>
);

// Message skeleton loader
export const MessageSkeleton = ({ isMine = false }) => (
  <div className={`flex ${isMine ? 'justify-end' : 'justify-start'} mb-3`}>
    <div className={`max-w-[75%] ${isMine ? 'ml-auto' : ''}`}>
      <Skeleton 
        className={`h-12 ${isMine ? 'w-48' : 'w-56'} rounded-2xl`}
        style={{ 
          backgroundColor: isMine ? 'rgba(124, 58, 237, 0.3)' : 'rgba(255, 255, 255, 0.1)' 
        }}
      />
      <div className={`flex ${isMine ? 'justify-end' : 'justify-start'} mt-1`}>
        <Skeleton className="h-2 w-12" />
      </div>
    </div>
  </div>
);

// Multiple message skeletons
export const MessageListSkeleton = ({ count = 8 }) => (
  <div className="space-y-2 p-4">
    {Array.from({ length: count }).map((_, i) => (
      <MessageSkeleton key={i} isMine={i % 3 === 0} />
    ))}
  </div>
);

// Chat header skeleton
export const ChatHeaderSkeleton = () => (
  <div className="flex items-center gap-3 p-4 animate-pulse">
    <Skeleton className="h-8 w-8 rounded-full" />
    <Skeleton className="w-10 h-10 rounded-full" />
    <div className="flex-1">
      <Skeleton className="h-4 w-24 mb-2" />
      <Skeleton className="h-3 w-16" />
    </div>
  </div>
);

// Dashboard skeleton
export const DashboardSkeleton = () => (
  <div className="p-4 space-y-4">
    {/* Header */}
    <div className="flex items-center justify-between mb-6">
      <Skeleton className="h-8 w-32" />
      <Skeleton className="h-10 w-10 rounded-full" />
    </div>
    
    {/* Search */}
    <Skeleton className="h-10 w-full rounded-lg" />
    
    {/* Conversations */}
    <div className="space-y-2 mt-4">
      <ConversationListSkeleton count={6} />
    </div>
  </div>
);

export default {
  ConversationSkeleton,
  ConversationListSkeleton,
  MessageSkeleton,
  MessageListSkeleton,
  ChatHeaderSkeleton,
  DashboardSkeleton
};
